import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

// Autres modules externes utilises 

// Modules communs utilises
import { ContextModule } from '../../technical-modules/context/context.module';
import { EventsModule } from '../../technical-modules/events/event-bus.module';

// Composants metiers
import { UserModule } from '../../data-domains/humain/user/user.module';
import { TestFunctionsComponent } from './component/test-functions.component';

// Services metier

// Bridges avec la partie angular
import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

@NgModule({
	imports: [
		BrowserModule,
		
		ContextModule,
		EventsModule,
		
		UserModule,
	],
	providers: [
	],
	declarations: [
		TestFunctionsComponent,
	],
	exports: [
	]
})
export class TestFunctionsModule {
	constructor() { }
}

angular.module('auroraApp') //
	.directive('testFunctions',
		downgradeComponent({ component: TestFunctionsComponent })
	) //
;